var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.67962 2.20927L3.18178 1.70711C3.57231 1.31658 4.20547 1.31658 4.59599 1.70711L8.07067 5.18178C8.46119 5.57231 8.4612 6.20547 8.07067 6.59599L6.66547 8.0012C6.46712 8.19955 6.41795 8.50256 6.54339 8.75345C7.99376 11.6542 10.3458 14.0062 13.2465 15.4566C13.4974 15.5821 13.8005 15.5329 13.9988 15.3345L15.404 13.9293C15.7945 13.5388 16.4277 13.5388 16.8182 13.9293L20.2929 17.404C20.6834 17.7945 20.6834 18.4277 20.2929 18.8182L19.7907 19.3204C17.6794 21.4317 14.3368 21.6693 11.9481 19.8777L8.9619 17.6381C7.21837 16.3304 5.66955 14.7816 4.36191 13.0381L2.12226 10.0519C0.330722 7.66318 0.568269 4.32062 2.67962 2.20927Z",
    stroke: "#414141",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ff1d1c3119bd6bbab82a7b9acc192abf.svg";
export { ForwardRef as ReactComponent };